import * as types from './types';

export function setServicesRequiringProofing(servicesRequiringProofing) {
	return { type: types.SET_SERVICES_REQUIRING_PROOFING, servicesRequiringProofing };
}
export function setPendingScheduleRequests(scheduleRequests) {
	return { type: types.SET_PENDING_SCHEDULE_REQUESTS, scheduleRequests };
}
